import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { StoredSettings, getTrainingSettings, saveTrainingSettings } from '@services/trainingSettingsService';
import { AthleteSettings } from '@services/engineService';
import { useUser } from './useUser';
import { queryKeys } from './queryKeys';

export const useTrainingSettings = () => {
  const { user } = useUser();
  const { data, isLoading, error } = useQuery<StoredSettings>({
    queryKey: queryKeys.trainingSettings,
    queryFn: getTrainingSettings,
    enabled: !!user?.plan_v2_id,
  });
  return { settings: data ?? null, isLoading, error };
};

/**
 * Saving replays selection and placement from tomorrow across the whole chain, so every cached
 * range of sessions and the progress counters are stale the moment it returns.
 */
export const useSaveTrainingSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (settings: AthleteSettings) => saveTrainingSettings(settings),
    onSuccess: (saved) => {
      queryClient.setQueryData(queryKeys.trainingSettings, saved);
      queryClient.invalidateQueries({ queryKey: ['enrollment-sessions'] });
      queryClient.invalidateQueries({ queryKey: queryKeys.progress });
    },
  });
};
